import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { ProductType } from '@xing-com/crate-common-graphql-types';
import { mediaWide } from '@xing-com/layout-tokens';
import {
  cornerRadiusS,
  spaceS,
  xdlPaletteMint11,
  xdlColorDimming,
  xdlColorTextOnDark,
  scale005,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

interface BestSellerFlagProps {
  visible: boolean;
  product: ProductType;
  className?: string;
}

export const BestSellerFlag: React.FC<BestSellerFlagProps> = ({
  visible,
  product,
  className = '',
}) => {
  return (
    <BestSellerFlagWrapper
      data-testid="best-seller-flag"
      className={className}
      visible={visible}
    >
      <BestSellerFlagInner product={product}>
        <BodyCopy as="span" size="xsmall" fontWeight="bold" sizeWide="xsmall">
          <FormattedMessage id="UPSELL_PURCHASE_OFFER_BOX_BEST_SELLER_FLAG" />
        </BodyCopy>
      </BestSellerFlagInner>
    </BestSellerFlagWrapper>
  );
};

const BestSellerFlagWrapper = styled.div<{ visible: boolean }>`
  display: flex;
  align-items: flex-start;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;

const BestSellerFlagInner = styled.span<{
  product: ProductType;
}>`
  display: inline-block;
  user-select: none;
  border-radius: ${cornerRadiusS};
  padding: 0 ${spaceS};

  ${({ product }) => css`
    background-color: ${product === ProductType.Premium
      ? xdlPaletteMint11
      : xdlColorDimming};
    span {
      color: ${xdlColorTextOnDark};
    }
  `}

  @media ${mediaWide} {
    padding: ${scale005} ${spaceS};
  }
`;
